import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';


@Component({
  selector: 'app-tab-tools',
  templateUrl: './tab-tools.component.html',
  styleUrls: ['../hourglass.component.css']
})
export class TabHourglassToolsComponent implements OnInit {
  token!: string;
  showModal = "none";
  userID: any = sessionStorage.getItem('wOSImpersonate') || sessionStorage.getItem('wOSAuthUser') || "";
  authUser: any = sessionStorage.getItem('wOSAuthUser');
  authAdmin: any = sessionStorage.getItem('wOSAdmin');
  errorMsg!: string;
  
  constructor(

    private sanitizer: DomSanitizer
  ) { }

  ngOnInit(): void {
    const user: any = sessionStorage.getItem("wOSUser");
    this.token = JSON.parse(user).stsTokenManager.accessToken;
  }

  clearError(): void {
    setTimeout(() => {
      this.errorMsg = ""
    }, 3500);
  }

  toggleModal(mode: string) {
    const icon = '<i class="fas fa-fw fa-lg fa-plus-square me-2"></i>'
    //$('.modal-title').html(icon + (('add' == 'add') ? 'Add' : 'Edit') + ' Content');
    this.showModal = (mode == 'show') ? "show" : "hide";
    ($('#contentModal') as any).modal(this.showModal);
  }
}
